import { Col, Row } from "antd";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";
import InputComponent from "../../../components/InputComponent";
import { InputStyle } from "./style";

const DocumentDetail = () => {
	const { documentUpdate, setDocumentUpdate } = useDocumentContext();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setDocumentUpdate((prev) => prev ? { ...prev, documentName: e.target.value } : prev);
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<InputComponent
						title={"Doküman Adı"}
						placeholder="Tamim No 5"
						isRequired
						style={InputStyle}
						value={documentUpdate?.documentName}
						onChange={handleChange}
					/>
				</Col>
			</Row>
		</>
	);
};

export default DocumentDetail;
